import { reverse } from 'lodash';
import React, { useRef, useEffect } from 'react'

interface GradientProps {
    width: number; 
    height: number; 
    ramp: []; 
    inverse: boolean;
}

const Gradient = ({ width, height, ramp, inverse }: GradientProps) => {
    
    const canvasRef = useRef<HTMLCanvasElement>(null);
  
    useEffect(() => {
        if (!canvasRef.current) {
            return; 
        }
            
        const canvas: HTMLCanvasElement = canvasRef.current;
            if(canvas != null) {
                const ctx = canvas.getContext('2d');

                if (ctx != null) {
                    draw(ctx);
                }
            }
    }, [ramp, inverse]);

    const draw = (ctx:any) => {
        var grd = ctx.createLinearGradient(0,0,width,0);

        ramp.forEach((step:any) => {
            //console.log("030123 step", step)
            const value = inverse ? 1.0 - step[0] : step[0];
            //console.log("030123 value", value)
            //grd.addColorStop(value, (step[1] === '#143fcc7f') ? "#143fcc" : step[1]);
            grd.addColorStop(value, step[1]);
        });
        //console.log("030123 grd", grd)
        // Fill with gradient
        ctx.fillStyle = grd;
        ctx.fillRect(0,0,width,height);
    }
    
    return (
        <canvas ref={canvasRef} width={width} height={height} />
    )
}

export default Gradient;